import { render, staticRenderFns } from "./LiveAssignmentDropdown.vue?vue&type=template&id=a7caad28&scoped=true"
import script from "./LiveAssignmentDropdown.vue?vue&type=script&lang=js"
export * from "./LiveAssignmentDropdown.vue?vue&type=script&lang=js"
import style0 from "./LiveAssignmentDropdown.vue?vue&type=style&index=0&id=a7caad28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7caad28",
  null
  
)

export default component.exports